import React, { useEffect, useState } from 'react';
import { Box, Paper, styled } from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(2),
  minHeight: '842px', // A4 height
  width: '595px', // A4 width
  backgroundColor: '#fff',
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
  fontSize: '12px',
  lineHeight: 1.4,
  '& *': {
    fontFamily: 'Times New Roman, serif',
  },
  '& .ProseMirror': {
    maxWidth: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    padding: '10px 20px',
    '& p': {
      maxWidth: '100%',
    },
    '& h3': {
      fontSize: '13px !important',
      fontWeight: 'bold',
    },
  },
}));

interface ActionItemsPreviewProps {
  actionItems: string;
}

const DEFAULT_ACTION_ITEMS_HTML = `
  <div class="action-items" style="font-family: Times New Roman, serif;">
    <h3 class="action-items-heading" style="font-weight: bold; margin-bottom: 0.5rem; font-size: 13px !important;">1.2. Action Items</h3>
    <p>Following is a summary of questions, comments, needs, or suggestions we have concerning our observations made at the site and our review of the Application for Payment and associated documentation.</p>
    <div style="margin-bottom: 1em;">1. [Add action items]</div>
  </div>
`;

const ActionItemsPreview: React.FC<ActionItemsPreviewProps> = ({ actionItems }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    setContent(actionItems || DEFAULT_ACTION_ITEMS_HTML);
  }, [actionItems]);

  return (
    <StyledPaper elevation={2}>
      <Box>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Box>
    </StyledPaper>
  );
};

export default ActionItemsPreview;
